module.exports = __webpack_public_path__ + "img/tl2.d48486b9.webp";